var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('div',{staticClass:"FAQ-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":_vm.imgSrc},on:{"click":_vm.handleSelect}})])])]),_c('right-icon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }